/* DailyTask  */
import { FEATURES } from '@constants/Text'
import * as dailyTask from './store'

export const PERMISSION = FEATURES.DAILYTASKS

export function dailyTasksModule({ store }) {
  store.registerModule('dailyTasks', { ...dailyTask, namespaced: true })
}

/**
 * Enquanto o módulo estiver em beta, vai apontar para a tela antiga.
 * @type {boolean}
 */
export const IS_BETA_DAILY_TASKS = false
